import { render, staticRenderFns } from "./WhatsAppBalloon.vue?vue&type=template&id=74cdd4cc&scoped=true"
import script from "./WhatsAppBalloon.vue?vue&type=script&lang=js"
export * from "./WhatsAppBalloon.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppBalloon.vue?vue&type=style&index=0&id=74cdd4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cdd4cc",
  null
  
)

export default component.exports